<template>
  <div class="associatedFile">
    <el-dialog v-dialogDrag append-to-body :visible.sync="fileDialog" :close-on-click-modal="false"
      :close-on-press-escape="false" :close="cancel" title="关联文件" width="600px">
      <el-tree ref="localTree" :load="getlocalTree" :data="localTree" :props="defaultFileProps"
        :check-on-click-node="true" class="tree" lazy accordion highlight-current show-checkbox
        @check="currentOrgChangeHandlerLocal">
        <template #default="{ data }">
          <span class="treeitem">
            <img v-if="data.isFolder == 0" :src="className(data)" class="img" alt="" />
            <img v-else :src="icon" class="img" alt="" />
            {{ data.folderName }}
          </span>
        </template>
      </el-tree>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="fileDialog = false">取消</el-button>
        <el-button type="primary" size="small" @click="filerecelocationBtn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import docService from "@/CommonDP/service/doc-service";
import { tableRowIcon } from "@/CommonDP/utils/docPublic";
export default {
  name: "AssociatedFile",
  props: {
    prjId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      fileDialog: true,
      localTree: [],
      defaultFileProps: {
        children: "childList",
        label: "folderName",
        isLeaf: "leaf"
      },
      currentFileLocal: {}, // 提资关联文档
      node_had: {},
      resolve_had: {},
      icon: require("@/CommonDP/assets/doc/folder_icon.png"),
      fileTree: [],
      floderData: []
    };
  },
  computed: {
    ...mapState({
      prjInfo: (state) => state.projectMg.prjObj
    })
  },
  watch: {},
  created() {},
  methods: {
    className(row) {
      return tableRowIcon(row);
    },
    cancel() {
      this.fileTree = [];
      this.localTree = [];
    },
    async getlocalTree(node, resolve) {
      const prjId = this.prjId || this.$route.query.prjId || this.prjInfo.prjId;
      if (node.level === 0) {
        this.node_had = node; // 这里是关键！在data里面定义一个变量，将node.level == 0的node存起来
        this.resolve_had = resolve; // 同上，把node.level == 0的resolve也存起来
        const params = {
          folderId: 0,
          isRead: 1,
          priviAll: "1",
          prjId,
          noRightClickMenu: true
        };
        const result = await docService.queryTree(params);
        const list = result.data.filter(({ folderId }) => folderId !== "recycle");
        const array = list.map((item) => {
          const { childFolder = 0 } = item;
          return {
            isRead: item.isRead,
            priviAll: item.priviAll,
            folderName: item.folderName,
            folderId: item.folderId,
            isFolder: item.isFolder,
            fileType: item.fileType,
            uploadType: 1,
            leaf: childFolder === 0
          };
        });
        return resolve(array);
      } else {
        // console.log('第二级');
        const params = {
          folderId: node.data.folderId,
          isRead: node.data.isRead,
          priviAll: node.data.priviAll,
          noRightClickMenu: true,
          prjId
        };
        await docService.queryTree(params).then(({ data }) => {
          const list = data.map((item) => {
            const { childFolder = 0 } = item;
            return {
              isRead: item.isRead,
              priviAll: item.priviAll,
              folderName: item.folderName,
              folderId: item.folderId,
              isFolder: item.isFolder,
              fileType: item.fileType,
              leaf: childFolder === 0,
              uploadType: 1
            };
          });
          return resolve(list);
        });
      }
    },
    async currentOrgChangeHandlerLocal(val, currentChecked) {
      this.currentFileLocal = currentChecked.checkedNodes;
    },
    async filerecelocationBtn() {
      // 对于通用流程关联文档，确定获取文件夹的子级文件
      const prjId = this.$route.query.prjId ? this.$route.query.prjId : this.prjInfo.prjId;
      if (this.currentFileLocal && this.currentFileLocal.length > 0) {
        const list = [];
        // 对于直接选择文件可以先拿出来
        const array = this.currentFileLocal.filter(({ isFolder }) => isFolder === 0);
        const arrayFolder = this.currentFileLocal.filter(({ isFolder }) => isFolder !== 0);
        const array11 = array.map((item) => {
          return {
            fileName: item.folderName,
            fileId: item.folderId,
            fileType: item.fileType,
            isFolder: item.isFolder,
            uploadType: 1
          };
        });
        // 选中的文件夹点击确定获取子级数据
        for (const item of arrayFolder) {
          const params = {
            folderId: item.folderId,
            isRead: item.isRead,
            priviAll: item.priviAll,
            noRightClickMenu: true,
            prjId
          };
          await docService.queryTree(params).then(({ data }) => {
            const listData = data.map((item) => {
              return {
                fileName: item.folderName,
                fileId: item.folderId,
                fileType: item.fileType,
                isFolder: item.isFolder,
                uploadType: 1
              };
            });
            list.push.apply(list, listData);
          });
        }
        // 将获取到的非文件过滤掉
        const listLocal = list.filter(({ isFolder }) => isFolder === 0);
        // 拼接原来选择的文件
        this.floderData = array11.concat(listLocal);
      }
      this.fileDialog = false;
      var obj = {};
      var floderDatanew = this.floderData.reduce((cur, next) => {
        obj[next.fileName] ? "" : (obj[next.fileName] = true && cur.push(next));
        return cur;
      }, []);
      this.$parent.getAssociatedFile(floderDatanew);
    },
    showDialog() {
      this.fileDialog = true;
    }
  }
};
</script>

<style scoped lang="scss">
.associatedFile {
  width: 100%;
  height: 70px;
}
/deep/ .el-dialog {
  border-radius: 5px;
  position: relative;
  min-height: 200px;
}
/deep/ .el-dialog__body {
  padding: 0px 20px 20px;
  height: calc(100% - 74px);
}
/deep/ .el-dialog__wrapper {
  width: 100% !important;
}
.tree {
  overflow: auto;
  height: 500px;
  max-height: 500px;
  width: 100%;
}
.treeitem {
  display: flex;
  align-items: center;
  user-select: none;
}
.img {
  margin-right: 6px;
  height: 16px;
  width: 18px;
  user-select: none;
}
.allShowBar {
  max-width: 800px !important;
}
/deep/ .el-tree-node__content {
  height: 26px !important;
}
</style>
